import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useContext} from "react";
import AuthContext from "../../context/AuthContext";
import IceButton from "../../components/Button";


export default function DialogPark(props: any) {
    let {user, authTokens, serverIP} = useContext(AuthContext)
    let {open, setOpen, keyDataSet, setMapInfo} = props

    function handlePark() {

        fetch(`${serverIP}/parkmap/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({...keyDataSet, user: user.username}),
        }).then(res => res.json())
            .then((data) => {
                if (data.code === 200) {
                    setMapInfo((prev: any) => {
                        return {...prev, mapStatus: 'parked'}
                    })
                    // console.log('Success')
                }
                // console.log(data)
            })

        setOpen(false)    // a dialog must be closed anyway after Save is clicked
    }

    return (

        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>Park mapping</DialogTitle>

            <DialogContent>

                <DialogContentText style={{fontSize: '0.85rem'}}>
                    You are going to park this mapping.<br/>
                    Mapping functionality will be disabled. Mapping status will be changed.<br/><br/>
                    Use "Comment" button to provide an explicit reason for parking this mapping.
                </DialogContentText>

            </DialogContent>

            <DialogActions>
                <IceButton type="primary" text="Park" onclick={handlePark} />
                <IceButton type="delete" text="Cancel" onclick={() => setOpen(false)} />
            </DialogActions>

        </Dialog>
    );
}